import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const clientZScoreReducer = createReducer(initialState, {
  CLIENT_ZSCORE_REQ: (state) => {
    state.loading = true;
    state.user = null;
  },
  CLIENT_ZSCORE_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  CLIENT_ZSCORE_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default clientZScoreReducer;
